class CheckOutSteps {
	constructor(params) {
		this.node = params.node;
		this.stepsNodes = this.node.getElementsByClassName('step-block');

		this.state = {
			currentStep: 1,
			stepsCount: this.stepsNodes.length,
		};
	}

	goToStep (stepNr, stepsCount = this.state.stepsCount) {
		const stepIndex = stepNr - 1;

		/**
		 * Hide payment method div on second step
		 * @todo: This part is obsolete
		 * @type {HTMLCollectionOf<Element>}
		 */
		const paymentMethod = document.getElementsByClassName('adventure__reviews mobile-reviews checkout-payment-method');
		if(stepNr === 2) {
			paymentMethod[0].classList.add('--hide');
		} else {
			paymentMethod[0].classList.remove('--hide');
		}
		// @endobsolete


		if (stepNr >= 1 && stepNr <= stepsCount) {
			this.state = {
				...this.state,
				currentStep: stepNr,
				stepsCount,
			};

			for (const content of this.stepsNodes) {
				content.classList.add('hidden');
			}
			this.stepsNodes[stepIndex].classList.remove('hidden');

			$('#current-step').text(stepNr);
		}
	};

	getNextState(stepNr) {


		return {
			nextStepOverLimits: stepNr,
			nextStep: stepNr >= 1 && stepNr <= this.state.stepsCount ? stepNr : this.state.currentStep,
			isFinal: stepNr === this.state.stepsCount,
		}
	};

	gotToNextStep(callback) {
		const isGood = callback(this.getNextState(this.state.currentStep + 1));
		if (isGood) this.goToStep(this.state.currentStep + 1);
	}

	goToPreviousStep(callback) {
		const isGood = callback(this.getNextState(this.state.currentStep - 1));
		if (isGood) this.goToStep(this.state.currentStep - 1);
	}
}

export default CheckOutSteps;